<!-- =========================================================================================
  File Name: UserThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"
      :isResetPassword="isResetPassword"  :isNewUser="isNewUser"/>
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="users">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-button v-if="userInfo.userType!='Member' && userInfo.userType!= 'Teamleader'"
           type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">{{ $t('AddNew') }}
        </vs-button>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ users.length - currentPage *
              itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }} of {{ users.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">{{ $t('Name') }}</vs-th>
        <vs-th sort-key="UserName">{{ $t('Email') }}</vs-th>
        <vs-th sort-key="Email">{{ $t('PhoneNumber') }}</vs-th>
        <vs-th sort-key="image">{{$t('Role')}}</vs-th>

        <vs-th sort-key="EmailConfirmed">{{ $t('Status') }}</vs-th>
        <!-- <vs-th sort-key="IsEmailConfirmed">{{ $t('Confirmation') }}</vs-th> -->

        <vs-th>{{ $t('Action') }}</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
          <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.stop="editData(tr)">

            <vs-td>
             <vs-td>{{ currentLocale === 'ar' ? tr.FullNameAr : tr.FullNameEn }}</vs-td>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.Email }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.PhoneNumber }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getPopularityColor(tr.RoleName)" class="product-order-status">{{ tr.RoleName }}</vs-chip>
            </vs-td>

            <vs-td>
                <vs-chip :color="getStatusColor(tr.EmailConfirmed)" class="product-order-status">{{ tr.EmailConfirmed == true? 'Approved' : 'Not Approved' }}</vs-chip>
            </vs-td>
            <!-- <vs-td>
              <vs-chip :color="getStatusColor(tr.IsConfirmed)" class="product-order-status">{{ tr.IsConfirmed}}</vs-chip>
            </vs-td> -->

            <vs-td class="whitespace-no-wrap">
              <div class="icon-container">
              <div>
                 <vx-tooltip text="Reset Password" position="top">
              <feather-icon icon="LockIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="resetPassword(tr)" />
              </vx-tooltip>
            </div>
            <div>
              <vx-tooltip text="Edit User" position="top">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                @click.stop="editData(tr)" />
              </vx-tooltip>
            </div>
            <div v-if="userInfo.userType!='Member' && userInfo.userType!= 'Teamleader' && userInfo.userType!='SubNationalManager'">
              <vx-tooltip color="green" text="Approve User" position="top">
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-10 h-5 hover:text-primary stroke-current"
                  v-if="tr.EmailConfirmed != true"
                  @click.stop="ConfirmApproveUser(tr)"
                />
              </vx-tooltip>
            </div>
            <div v-if="userInfo.userType!='Member' && userInfo.userType!= 'Teamleader'">
              <vx-tooltip color="red" text="Delete User" position="top">
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click.stop="ConfirmDeleteUser(tr)" />
              </vx-tooltip>
            </div>
              </div>
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>

import DataViewSidebar from "./DataViewSidebar.vue";
import moduleUser from "@/store/user/moduleUser.js";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { domain } from '@/gloabelConstant.js'

export default {
  components: {
    DataViewSidebar,
    VueSimpleSuggest
  },
  data() {
    return {
      user: {},
      url: domain,
      selected: [],
      // users: [],
      first: true,
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      chosen: "",
      isResetPassword: false,
      isNewUser: false,
      userInfo: {}
    };
  },
  computed: {
        currentLocale() {
      return this.$i18n.locale;
    },

    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    users() {
      
      return this.$store.state.UserList.users;
    }
  },
  methods: {

    notifyAlert(color, title, text) {
      this.$vs.notify({
        time: 8000,
        color: color,
        title: title,
        text: text
      });
    },
    addNewData() {
      
      this.isResetPassword = false;
      this.isNewUser = true;
      this.sidebarData = {};
      this.sidebarData.countryId = this.userInfo.countryId;
      this.sidebarData.governorateId = this.userInfo.governorateId;
      this.toggleDataSidebar(true);
    },
    ConfirmDeleteUser(data) {
      this.user = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.deleteUser
      });
    },

deleteUser() {
  this.$store.dispatch("UserList/removeUser", this.user.Id).then(() => {
    this.$vs.notify({
      time: 8000,
      color: "success",
      title: "Delete User",
      text: "User is Deleted Successfully",
    });
  }).catch(err => {
    const errorMessage = (err.response && err.response.data && err.response.data.message) 
                         ? err.response.data.message 
                         : "Error occurred";
    this.$vs.notify({
      time: 8000,
      color: "danger",
      title: "Delete User",
      text: errorMessage
    });
    console.error(err);
  });
},

    ConfirmApproveUser(data) {
      
      this.rowDataForApprove = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Confirm Approve User",
        accept: this.acceptApprove,
        acceptText: "Approve",
        cancelText: "Cancel",
      });
    },
    acceptApprove() {
      this.ApproveUser(this.rowDataForApprove);

    },

   ApproveUser(data) {

  this.$store.dispatch("UserList/approveUser", data.Id).then(() => {
    this.$store.dispatch("UserList/fetchDataListItems");
    this.$vs.notify({
      color: "success",
      title: "Approve User",
      text: "User Approved Successfully",
    });
  })
  .catch((err) => {
    this.$vs.notify({
      time: 8000,
      color: "danger",
      title: "Error",
      text: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : "Error occurred"
    });
    console.error(err);
  });
},

    resetPassword(data) {
      this.sidebarData = data;
      this.isResetPassword = true;
      this.isNewUser = false;
      this.toggleDataSidebar(true);
    },

    editData(data) {
      
      this.isResetPassword = false;
      this.isNewUser = false;
      this.sidebarData = data;
      //in edit password not editable so fill it with any pass to can save because it is required
      //this.sidebarData.Password = "Abc_123456";
      this.toggleDataSidebar(true);
    },
    getStatusColor(status) {
      if (status == true) return "success";
      else return "danger";
    },
   getPopularityColor(role) {
      switch (role) {
        case 'SuperAdmin':
          return "black";
        case 'Admin':
          return "darkBlue";
        case 'Regulator':
          return "DarkRed";
        case 'Investor':
          return "gray";
        case 'Operator':
          return "SkyBlue";
        case 'Internal':
          return "blue";
        default:
          return "SkyBlue"; // اللون الافتراضي
      }
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    simpleSuggestionList() {
      return ["Vue.js", "React.js", "Angular.js"];
    }
  },
  created() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule("UserList", moduleUser);
      moduleUser.isRegistered = true;
    }

    
    this.$store.dispatch("UserList/fetchDataListItems");
    this.$store.dispatch("UserList/GetAllRoles");

    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
.icon-container{
    display: flex;
  }
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";</style>
